// extracted by mini-css-extract-plugin
module.exports = {"root":"WebinarBanner_root__RuHGx","title":"WebinarBanner_title__49_sx","time":"WebinarBanner_time__6RcfE","desc":"WebinarBanner_desc__3PM3n"};